import { render } from "./vipGift.vue?vue&type=template&id=32bb4f19&scoped=true"
import script from "./vipGift.vue?vue&type=script&lang=js"
export * from "./vipGift.vue?vue&type=script&lang=js"

import "./vipGift.vue?vue&type=style&index=0&id=32bb4f19&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb4f19"]])

export default __exports__